import { FETCH_COUPON, ADD_COUPON, EDIT_COUPON, DELETE_COUPON, DESTROY_COUPON } from "../actionTypes";

export const fetchCoupon = coupons => ({
    type: FETCH_COUPON,
    coupons
});

export const addCoupon = coupon => ({
    type: ADD_COUPON,
    coupon
});

export const editCoupon = coupon => ({
    type: EDIT_COUPON,
    coupon
});

export const deleteCoupon = id => ({
    type: DELETE_COUPON,
    id
});

export const destroyCoupon = key => ({
    type: DESTROY_COUPON,
    key
});